<template>
   <div class="editMap">
        <el-tabs v-model="activeName" @tab-click="handleClick" type="border-card">
            <el-tab-pane label="业态分布" name="ytfb">
              <div class="ytfb"></div>
            </el-tab-pane>
            <el-tab-pane label="合同到期" name="htdq">
              <div class="htdq"></div>
            </el-tab-pane>
            <el-tab-pane label="招商预警" name="zsyj">
              <div class="zsyj"></div>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import req from "@/request.js";
export default {
  name: "EditMap",
  data() {
    return {
      fdbh:0,
      activeName: 'ytfb',
      conheight: { height: (window.innerHeight-42)  + "px",width:"100%"},
    };
  },
  methods: {
    handleClick(tab, event) {
      $(".ytfb").html("");
      $(".htdq").html("");
      $(".zsyj").html("");
      let ERP_DEPT = JSON.parse(sessionStorage.getItem("ERP_DEPT"));
      if(ERP_DEPT.length>=0){
        if(tab.name == "ytfb") {//业态分布
          $(".ytfb").append('<iframe src="static/editMap_ytfb.html" scrolling="no" style="width:100%;height:'+(window.innerHeight-42)+"px"+'" frameborder="0"></iframe>');
        }

        if(tab.name == "htdq") {//合同到期
          $(".htdq").append('<iframe src="static/editMap_htdq.html" scrolling="no" style="width:100%;height:'+(window.innerHeight-42)+"px"+'" frameborder="0"></iframe>');
        }

        if(tab.name == "zsyj") {//招商预警
          $(".zsyj").append('<iframe src="static/editMap_zsyj.html" scrolling="no" style="width:100%;height:'+(window.innerHeight-42)+"px"+'" frameborder="0"></iframe>');
        }
      }
    }
  },
  mounted(){
    let this_ = this;
    req.post(window.context.bpmRunTime + "/bpm/haiyaScript/executeSql?param="+Base64.encode('SELECT WLDPDM,SHOPDM,YT,ZT,SHOPMC,PXZ,PXBZ,PXB FROM bfbhdd8.V_PUWEIGL@bfbhdd8 WHERE FDBH=201')).then(resp=>{
      sessionStorage.setItem("ERP_PW",JSON.stringify(resp.data.result));
      sessionStorage.setItem("netUrl",window.context.bpmRunTime)
    });
    let User = JSON.parse(window.sessionStorage.currentUser);
    req.post(window.context.bpmRunTime + "/bpm/haiyaScript/executeSql?param="+Base64.encode('select a.floor,a.fdbh from ERP_JGZX@BFBHDD8 a where a.rydm="+User.account +"order by a.floor desc')).then(resp=>{
      if(resp.data.result.length>=0){
        sessionStorage.setItem("ERP_DEPT",JSON.stringify(resp.data.result));
        this_.fdbh = resp.data.result[0].FDBH;//后续门店上线需按门店区分入口，现阶段按楼层分
        $(".ytfb").append('<iframe src="static/editMap_ytfb.html" scrolling="no" style="width:100%;height:'+(window.innerHeight-42)+"px"+'" frameborder="0"></iframe>');
      }
    });

    
  },
};
</script>


<style lang="scss" scoped>
@import "@/assets/css/element-variables.scss";

/deep/ .el-tabs__header{
  margin: 0px !important;
  padding-top: 0px !important;
  text-align: center !important;
  border: 0px !important;
}

/deep/ .el-tabs--border-card{
  border: 0px !important;
}

/deep/ .el-tabs__active-bar{
  display: none !important;
}

/deep/ .el-tabs__nav{
  width: 100% !important;
}

/deep/ .el-tabs__content{
  padding: 0px !important;
}
</style>